package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.celestialbodies.CelestialBody

object OrbitalBodyRenderer : CelestialBodyRenderer() {

    override val abbrevLabelFontSize = 20.0f
    internal var DEF_SIZE = 15.0
    internal var DEF_SUN_MOON_SIZE = 30.0
    internal var DEF_COL = SP_Colour(150,150,150,255)// GRAY
    internal var TITLE_COL = SP_Colour(255,255,255,255) // WHITE


    override fun getDiameter(b: CelestialBody): Double {
        var diameter = DEF_SIZE
        if (b.name === "Sun" || b.name === "Moon") {
            diameter = DEF_SUN_MOON_SIZE
        }

        return diameter
    }

    override fun getColour(c: CelestialBody):SP_Colour { return c.rgbColour }

}